import { ref } from "vue";

export function useIsMobile() {
  const windowWidth = ref(
    typeof window !== "undefined" ? window.innerWidth : 0,
  );
  const isMobile = ref(windowWidth.value <= 991);

  // Function to check if the device is mobile
  function checkIsMobile() {
    windowWidth.value = typeof window !== "undefined" ? window.innerWidth : 0;
    isMobile.value = windowWidth.value <= 991;
  }

  // Utility to manually trigger a check (useful for reactivity in other parts of the app)
  function updateWidth() {
    checkIsMobile();
  }

  // Immediately set the initial state
  checkIsMobile();

  return { isMobile, windowWidth, updateWidth };
}
